// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2g-Zx","label":"Category_label__1pQXZ","content":"Category_content__2Pgtz","header":"Category_header__2JAQQ","location":"Category_location__3IgSf"};